import { render, staticRenderFns } from "./BasePublisherForm.vue?vue&type=template&id=babdc1f6&scoped=true&"
import script from "./BasePublisherForm.vue?vue&type=script&lang=js&"
export * from "./BasePublisherForm.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./BasePublisherForm.vue?vue&type=style&index=1&id=babdc1f6&scoped=true&lang=css&"
import style2 from "./BasePublisherForm.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babdc1f6",
  null
  
)

export default component.exports